import React from 'react';

import { Fab } from '@mui/material';

import {
  LOAN_TERMS,
  LOAN_TERM_HEADER,
  SELECTED_TAB_STYLE,
} from '../../constants/Dashboard/Financing';

import './LoanTermTabs.css';

export const LoanTermTabs = ({
  handleLoanTermClick,
  selectedLoanTerms,
  financeLoanTerms = LOAN_TERMS,
}) => {
  return (
    <div className="auto-mortgage-loan-terms-wrapper">
      <p className="auto-mortgage-loan-term-header">{LOAN_TERM_HEADER}</p>
      <div className="auto-mortgage-loan-term-tabs-wrapper">
        {Object.keys(financeLoanTerms).map((loanTerm) => {
          const additionalStyling = selectedLoanTerms[loanTerm] ? SELECTED_TAB_STYLE : {};
          return (
            <Fab
              key={loanTerm}
              sx={{
                '&:hover': { backgroundColor: 'white', color: 'black' },
                color: 'black',
                textTransform: 'initial',
                backgroundColor: 'white',
                width: { xs: '28%', sm: '22%' },
                m: 1,
                ...additionalStyling,
              }}
              variant="extended"
              size="large"
              onClick={() => handleLoanTermClick(loanTerm)}
            >
              {financeLoanTerms?.[loanTerm]?.text}
            </Fab>
          );
        })}
      </div>
    </div>
  );
};
